import { render, staticRenderFns } from "./change-avatar.vue?vue&type=template&id=7eff63c4&scoped=true"
import script from "./change-avatar.vue?vue&type=script&lang=js"
export * from "./change-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eff63c4",
  null
  
)

export default component.exports